export default "__VITE_ASSET__BuYhucbs__"